export default __webpack_public_path__ + "static/media/Ingrid.6e803c46.jpeg";